import axios from 'axios';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import jwtDecode from 'jwt-decode';
import { isEmpty } from 'lodash';
import moment from 'moment/moment';

export function formatCurrency(value, minFD = 2, maxFD = 2, currency) {
    return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: currency ?? 'NGN',
        maximumFractionDigits: maxFD,
        minimumFractionDigits: minFD,
    }).format(value);
}

export const addCommasToNumber = (number) => {
    if (!number && number !== 0) return;
    if (number === 0) return 0;
    number = number.toString();
    if (number.includes('.')) {
        const parts = number.split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts.slice(1).join('');
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatDate = (date, format = 'D/M/YYYY') => moment(date).format(format);

export const getDateInterval = (date) => moment(date).fromNow();

export const calculateEarnings = (tierPrices, price) => {
    if (!tierPrices.length) return <WalletHistoryPrice price={0} />;
    const highestTier = Array.isArray(tierPrices) ? tierPrices?.pop() : 0;
    const calculateDiff = (price - highestTier.value || 0) * highestTier.qty || 1;
    return <WalletHistoryPrice price={calculateDiff} />;
};

export const addToStoreCart = (cartItems, newItem) => {
    const foundIndex = cartItems.findIndex((item) => newItem.id === item.id);
    if (foundIndex >= 0) {
        const updatedItem = cartItems[foundIndex];
        const qty = updatedItem.qty + 1;
        cartItems[foundIndex] = { ...updatedItem, qty };
        return cartItems;
    }
    return [...cartItems, { ...newItem, qty: 1 }];
};

export const removeFromStoreCart = (cartItems, item) => {
    return cartItems.filter((cartItem) => cartItem.id !== item.id);
};

export const calculateProfit = (product, symbol, convertedPrice = 0) => {
    if (!product) return null;
    if (product?.cf_packs) {
        return `Earn up to ${symbol} ${addCommasToNumber(
            ((3 / 100) * convertedPrice).toFixed(2),
        )} / unit`;
    }
    return null;
};

export const calculateCartTotal = (cartItems) => {
    return !isEmpty(cartItems?.items)
        ? cartItems?.items?.reduce((a, b) => Number(a) + Number(b.total_price || 1), 0)
        : 0;
};

export const ITEMS_PER_PAGE = 24;

export const toInitials = (str) => {
    if (!str) return;
    const strArr = str.split(' ');
    const newArr = strArr.map((item) => item[0]?.toUpperCase());
    return newArr.join('');
};

export const slas = [
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Liberia',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Liberia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Liberia',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Liberia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Liberia',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Liberia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Liberia',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Gambia',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Gambia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Gambia',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Gambia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Gambia',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Gambia',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Gambia',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Cape Verde',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Guinea-Bissau',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Benin Republic',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Senegal',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Senegal',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Senegal',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Senegal',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Senegal',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Senegal',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Senegal',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Ivory Coast',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
    {
        vendorRegion: 'West Africa',
        customerRegion: 'Nigeria',
        airDeliveryDays: '1 - 7',
        seaDeliveryDays: 'N/A (Local Delivery)',
    },
    {
        vendorRegion: 'East Africa',
        customerRegion: 'Nigeria',
        airDeliveryDays: '3 - 7',
        seaDeliveryDays: '15 - 30',
    },
    {
        vendorRegion: 'North Africa',
        customerRegion: 'Nigeria',
        airDeliveryDays: '4 - 9',
        seaDeliveryDays: '20 - 40',
    },
    {
        vendorRegion: 'Southern Africa',
        customerRegion: 'Nigeria',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Asia',
        customerRegion: 'Nigeria',
        airDeliveryDays: '7 - 14',
        seaDeliveryDays: '35 - 70',
    },
    {
        vendorRegion: 'Europe',
        customerRegion: 'Nigeria',
        airDeliveryDays: '5 - 10',
        seaDeliveryDays: '25 - 50',
    },
    {
        vendorRegion: 'Americas',
        customerRegion: 'Nigeria',
        airDeliveryDays: '8 - 15',
        seaDeliveryDays: '40 - 80',
    },
];

export function getDeliveryTimeline(vendorCountry, customerCountry) {
    // Step 1: Check for direct country match
    let match = slas?.find(
        (entry) => entry.vendorRegion === vendorCountry && entry.customerRegion === customerCountry,
    );

    // Step 2: If no direct country match, check for regional match
    if (!match) {
        const vendorRegion = getRegion(vendorCountry);

        if (vendorRegion) {
            match = slas?.find(
                (entry) =>
                    entry.vendorRegion === vendorRegion && entry.customerRegion === customerCountry,
            );
        }
    }

    // Step 3: Return the result or a fallback message
    return match
        ? {
              airDeliveryDays: match.airDeliveryDays,
              seaDeliveryDays: match.seaDeliveryDays,
          }
        : {
              airDeliveryDays: '7 - 14',
              seaDeliveryDays: '35 - 90',
          };
}

export function getRegion(country) {
    // Define mappings from countries to regions
    const regionMap = {
        // West Africa
        Liberia: 'West Africa',
        Gambia: 'West Africa',
        'Cape Verde': 'West Africa',
        'Guinea-Bissau': 'West Africa',
        'Benin Republic': 'West Africa',
        Senegal: 'West Africa',
        'Ivory Coast': 'West Africa',
        Nigeria: 'West Africa',

        // East Africa
        Kenya: 'East Africa',
        Tanzania: 'East Africa',

        // North Africa
        Egypt: 'North Africa',
        Morocco: 'North Africa',

        // Southern Africa
        'South Africa': 'Southern Africa',
        Zimbabwe: 'Southern Africa',
        // Asia
        China: 'Asia', // Example for Asia
        India: 'Asia', // Example for Asia

        // Europe
        'United Kingdom': 'Europe',
        France: 'Europe',
        Germany: 'Europe',

        // Americas
        'United States': 'Americas',
        Brazil: 'Americas',
        Canada: 'Americas',
    };

    return regionMap[country] || null;
}

export function generateSubcategoriesArray(categories) {
    const flattenedCategories = [];

    function processCategory(category, parentName = null, rootName = null) {
        // Determine the root category name
        const rootCategory = rootName || category.name;

        if (
            category.sub_categories &&
            category.sub_categories.length > 0 &&
            category.status === 'active'
        ) {
            category.sub_categories.forEach((subCategory) => {
                const transformedCategory = {
                    id: subCategory.id,
                    category_id: subCategory.category_id,
                    name: subCategory.name,
                    image: subCategory.image,
                    description: subCategory.description,
                    parent_category: category.name,
                    parent_id: subCategory.parent_id,
                    root_category: rootCategory,
                    createdAt: subCategory.createdAt,
                    updatedAt: subCategory.updatedAt,
                    status: subCategory.status,
                    hasSubcategories: subCategory.sub_categories.length > 0,
                    sub_categories:
                        subCategory.sub_categories.length > 0 ? subCategory.sub_categories : [],
                };

                // Add the transformed category to the result
                flattenedCategories.push(transformedCategory);

                // Recursively process nested sub-categories
                processCategory(subCategory, subCategory.name, rootCategory);
            });
        }
    }

    // Process each main category
    categories.forEach((category) => {
        processCategory(category);
    });

    return flattenedCategories;
}
export function isCurrentDateEqualOrLess(targetTimestamp) {
    // Convert Unix timestamp to Date object

    // Current timestamp in seconds
    const currentTimestamp = Math.floor(Date.now() / 1000);
    // Check if current date is equal to or less than the target timestamp
    const isEqualOrLess = currentTimestamp <= targetTimestamp;
    return isEqualOrLess;
}

/**
 * Flattens the attributes object from the auth user, handling both nested and flat structures
 * @param attributes - The attributes object from the auth user
 * @returns A flattened object with all properties at the root level
 */
export function flattenAttributes(attributes) {
    const flattened = {};

    function flattenObject(obj, prefix = '') {
        for (const [key, value] of Object.entries(obj)) {
            const newKey = key;

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                flattenObject(value, newKey);
            } else {
                flattened[newKey] = value;
            }
        }
    }

    flattenObject(attributes);
    return flattened;
}

/**
 * Type guard to check if an object has nested attributes structure
 */
function hasNestedAttributes(obj) {
    return (
        'user_information' in obj || 'partner_information' in obj || 'payment_information' in obj
    );
}

/**
 * Transforms the auth user object by flattening its attributes
 * @param user - The auth user object
 * @returns The transformed user object with flattened attributes
 */
export function transformAuthUser(user) {
    if (!user) return;
    if (!user?.attributes) return user;

    const attributes = user.attributes;
    const flattenedAttributes = hasNestedAttributes(attributes)
        ? flattenAttributes(attributes)
        : attributes;

    return {
        ...user,
        attributes: flattenedAttributes,
    };
}
export function formatCurrencies(resp) {
    const rates = resp.data.usd; // all rates relative to USD
    return allowedCurrencies
        .filter((symbol) => rates[symbol.toLowerCase()]) // keep only allowed & available
        .map((symbol) => {
            const rate = rates[symbol.toLowerCase()];
            return {
                symbol,
                buy: rate, // you can apply markup here if needed
                sell: rate, // or apply different spread
            };
        });
}
const allowedCurrencies = [
    'NGN',
    'GHS',
    'ZAR',
    'KES',
    'RWF',
    'UGX',
    'TZS',
    'USD',
    'USDC',
    'USDT',
    'GBP',
    'XOF',
    'XAF',
];

export const countryToCurrency = {
    AF: 'AFN', // Afghanistan
    AL: 'ALL', // Albania
    DZ: 'DZD', // Algeria
    AS: 'USD', // American Samoa
    AD: 'EUR', // Andorra
    AO: 'AOA', // Angola
    AI: 'XCD', // Anguilla
    AQ: 'USD', // Antarctica
    AG: 'XCD', // Antigua and Barbuda
    AR: 'ARS', // Argentina
    AM: 'AMD', // Armenia
    AW: 'AWG', // Aruba
    AU: 'AUD', // Australia
    AT: 'EUR', // Austria
    AZ: 'AZN', // Azerbaijan
    BS: 'BSD', // Bahamas
    BH: 'BHD', // Bahrain
    BD: 'BDT', // Bangladesh
    BB: 'BBD', // Barbados
    BY: 'BYN', // Belarus
    BE: 'EUR', // Belgium
    BZ: 'BZD', // Belize
    BJ: 'XOF', // Benin
    BM: 'BMD', // Bermuda
    BT: 'BTN', // Bhutan
    BO: 'BOB', // Bolivia
    BA: 'BAM', // Bosnia and Herzegovina
    BW: 'BWP', // Botswana
    BR: 'BRL', // Brazil
    IO: 'USD', // British Indian Ocean Territory
    VG: 'USD', // British Virgin Islands
    BN: 'BND', // Brunei
    BG: 'BGN', // Bulgaria
    BF: 'XOF', // Burkina Faso
    BI: 'BIF', // Burundi
    KH: 'KHR', // Cambodia
    CM: 'XAF', // Cameroon
    CA: 'CAD', // Canada
    CV: 'CVE', // Cape Verde
    KY: 'KYD', // Cayman Islands
    CF: 'XAF', // Central African Republic
    TD: 'XAF', // Chad
    CL: 'CLP', // Chile
    CN: 'CNY', // China
    CX: 'AUD', // Christmas Island
    CC: 'AUD', // Cocos (Keeling) Islands
    CO: 'COP', // Colombia
    KM: 'KMF', // Comoros
    CG: 'XAF', // Congo
    CD: 'CDF', // Congo (DRC)
    CK: 'NZD', // Cook Islands
    CR: 'CRC', // Costa Rica
    CI: 'XOF', // Côte d'Ivoire
    HR: 'HRK', // Croatia
    CU: 'CUP', // Cuba
    CW: 'ANG', // Curaçao
    CY: 'EUR', // Cyprus
    CZ: 'CZK', // Czechia
    DK: 'DKK', // Denmark
    DJ: 'DJF', // Djibouti
    DM: 'XCD', // Dominica
    DO: 'DOP', // Dominican Republic
    EC: 'USD', // Ecuador
    EG: 'EGP', // Egypt
    SV: 'USD', // El Salvador
    GQ: 'XAF', // Equatorial Guinea
    ER: 'ERN', // Eritrea
    EE: 'EUR', // Estonia
    SZ: 'SZL', // Eswatini
    ET: 'ETB', // Ethiopia
    FK: 'FKP', // Falkland Islands
    FO: 'DKK', // Faroe Islands
    FJ: 'FJD', // Fiji
    FI: 'EUR', // Finland
    FR: 'EUR', // France
    GF: 'EUR', // French Guiana
    PF: 'XPF', // French Polynesia
    TF: 'EUR', // French Southern Territories
    GA: 'XAF', // Gabon
    GM: 'GMD', // Gambia
    GE: 'GEL', // Georgia
    DE: 'EUR', // Germany
    GH: 'GHS', // Ghana
    GI: 'GIP', // Gibraltar
    GR: 'EUR', // Greece
    GL: 'DKK', // Greenland
    GD: 'XCD', // Grenada
    GP: 'EUR', // Guadeloupe
    GU: 'USD', // Guam
    GT: 'GTQ', // Guatemala
    GG: 'GBP', // Guernsey
    GN: 'GNF', // Guinea
    GW: 'XOF', // Guinea-Bissau
    GY: 'GYD', // Guyana
    HT: 'HTG', // Haiti
    HN: 'HNL', // Honduras
    HK: 'HKD', // Hong Kong
    HU: 'HUF', // Hungary
    IS: 'ISK', // Iceland
    IN: 'INR', // India
    ID: 'IDR', // Indonesia
    IR: 'IRR', // Iran
    IQ: 'IQD', // Iraq
    IE: 'EUR', // Ireland
    IM: 'GBP', // Isle of Man
    IL: 'ILS', // Israel
    IT: 'EUR', // Italy
    JM: 'JMD', // Jamaica
    JP: 'JPY', // Japan
    JE: 'GBP', // Jersey
    JO: 'JOD', // Jordan
    KZ: 'KZT', // Kazakhstan
    KE: 'KES', // Kenya
    KI: 'AUD', // Kiribati
    XK: 'EUR', // Kosovo
    KW: 'KWD', // Kuwait
    KG: 'KGS', // Kyrgyzstan
    LA: 'LAK', // Laos
    LV: 'EUR', // Latvia
    LB: 'LBP', // Lebanon
    LS: 'LSL', // Lesotho
    LR: 'LRD', // Liberia
    LY: 'LYD', // Libya
    LI: 'CHF', // Liechtenstein
    LT: 'EUR', // Lithuania
    LU: 'EUR', // Luxembourg
    MO: 'MOP', // Macau
    MG: 'MGA', // Madagascar
    MW: 'MWK', // Malawi
    MY: 'MYR', // Malaysia
    MV: 'MVR', // Maldives
    ML: 'XOF', // Mali
    MT: 'EUR', // Malta
    MH: 'USD', // Marshall Islands
    MQ: 'EUR', // Martinique
    MR: 'MRU', // Mauritania
    MU: 'MUR', // Mauritius
    YT: 'EUR', // Mayotte
    MX: 'MXN', // Mexico
    FM: 'USD', // Micronesia
    MD: 'MDL', // Moldova
    MC: 'EUR', // Monaco
    MN: 'MNT', // Mongolia
    ME: 'EUR', // Montenegro
    MS: 'XCD', // Montserrat
    MA: 'MAD', // Morocco
    MZ: 'MZN', // Mozambique
    MM: 'MMK', // Myanmar
    NA: 'NAD', // Namibia
    NR: 'AUD', // Nauru
    NP: 'NPR', // Nepal
    NL: 'EUR', // Netherlands
    NC: 'XPF', // New Caledonia
    NZ: 'NZD', // New Zealand
    NI: 'NIO', // Nicaragua
    NE: 'XOF', // Niger
    NG: 'NGN', // Nigeria
    NU: 'NZD', // Niue
    NF: 'AUD', // Norfolk Island
    KP: 'KPW', // North Korea
    MK: 'MKD', // North Macedonia
    MP: 'USD', // Northern Mariana Islands
    NO: 'NOK', // Norway
    OM: 'OMR', // Oman
    PK: 'PKR', // Pakistan
    PW: 'USD', // Palau
    PS: 'ILS', // Palestine
    PA: 'PAB', // Panama
    PG: 'PGK', // Papua New Guinea
    PY: 'PYG', // Paraguay
    PE: 'PEN', // Peru
    PH: 'PHP', // Philippines
    PN: 'NZD', // Pitcairn Islands
    PL: 'PLN', // Poland
    PT: 'EUR', // Portugal
    PR: 'USD', // Puerto Rico
    QA: 'QAR', // Qatar
    RE: 'EUR', // Réunion
    RO: 'RON', // Romania
    RU: 'RUB', // Russia
    RW: 'RWF', // Rwanda
    BL: 'EUR', // Saint Barthélemy
    SH: 'SHP', // Saint Helena
    KN: 'XCD', // Saint Kitts and Nevis
    LC: 'XCD', // Saint Lucia
    MF: 'EUR', // Saint Martin
    PM: 'EUR', // Saint Pierre and Miquelon
    VC: 'XCD', // Saint Vincent and the Grenadines
    WS: 'WST', // Samoa
    SM: 'EUR', // San Marino
    ST: 'STN', // São Tomé and Príncipe
    SA: 'SAR', // Saudi Arabia
    SN: 'XOF', // Senegal
    RS: 'RSD', // Serbia
    SC: 'SCR', // Seychelles
    SL: 'SLL', // Sierra Leone
    SG: 'SGD', // Singapore
    SX: 'ANG', // Sint Maarten
    SK: 'EUR', // Slovakia
    SI: 'EUR', // Slovenia
    SB: 'SBD', // Solomon Islands
    SO: 'SOS', // Somalia
    ZA: 'ZAR', // South Africa
    KR: 'KRW', // South Korea
    SS: 'SSP', // South Sudan
    ES: 'EUR', // Spain
    LK: 'LKR', // Sri Lanka
    SD: 'SDG', // Sudan
    SR: 'SRD', // Suriname
    SE: 'SEK', // Sweden
    CH: 'CHF', // Switzerland
    SY: 'SYP', // Syria
    TW: 'TWD', // Taiwan
    TJ: 'TJS', // Tajikistan
    TZ: 'TZS', // Tanzania
    TH: 'THB', // Thailand
    TL: 'USD', // Timor-Leste
    TG: 'XOF', // Togo
    TK: 'NZD', // Tokelau
    TO: 'TOP', // Tonga
    TT: 'TTD', // Trinidad and Tobago
    TN: 'TND', // Tunisia
    TR: 'TRY', // Turkey
    TM: 'TMT', // Turkmenistan
    TC: 'USD', // Turks and Caicos Islands
    TV: 'AUD', // Tuvalu
    UG: 'UGX', // Uganda
    UA: 'UAH', // Ukraine
    AE: 'AED', // United Arab Emirates
    GB: 'GBP', // United Kingdom
    US: 'USD', // United States
    UM: 'USD', // U.S. Minor Outlying Islands
    UY: 'UYU', // Uruguay
    UZ: 'UZS', // Uzbekistan
    VU: 'VUV', // Vanuatu
    VA: 'EUR', // Vatican City
    VE: 'VES', // Venezuela
    VN: 'VND', // Vietnam
    VI: 'USD', // U.S. Virgin Islands
    WF: 'XPF', // Wallis and Futuna
    EH: 'MAD', // Western Sahara
    YE: 'YER', // Yemen
    ZM: 'ZMW', // Zambia
    ZW: 'ZWL', // Zimbabwe
};

/**
 * Get the currency code for a given country code.
 * If the mapped currency is not in the allowed set, returns 'USD'.
 * @param countryCode ISO 2-letter country code (e.g. 'NG', 'GH')
 * @returns Currency code (e.g. 'NGN', 'USD')
 */
export function getCurrencyCodeForCountry(countryCode) {
    const code = countryToCurrency[countryCode];
    return allowedCurrencies.includes(code) ? code : 'USD';
}

export const checkReturnable = (orderDate, status) => {
    const now = new Date();
    const newOrderDate = new Date(orderDate);
    // The order must not be older than 5 days.

    return moment(now).diff(moment(newOrderDate), 'days') <= 5 && status === 'fulfilled';
};

export async function getPriceByDate(date, currency) {
    if (!date || !date.includes('T')) return;
    const newDate = date?.split('T')?.[0];

    // Get existing data from localStorage
    const existingData = localStorage.getItem('currencyRateByDate');
    let currencyRateByDate = existingData ? JSON.parse(existingData) : [];

    // Check if data for this date and currency already exists
    const existingEntry = currencyRateByDate?.find(
        (entry) => entry.date === newDate && entry.symbol === currency,
    );

    if (existingEntry) {
        return existingEntry;
    } else {
        try {
            // Make API call if data doesn't exist in localStorage
            const resp = await axios.get(
                `https://${newDate}.currency-api.pages.dev/v1/currencies/usd.json`,
            );

            const data = {
                symbol: currency,
                date: newDate,
                rate: resp?.data?.usd?.[currency?.toLowerCase()],
            };

            // Add new data to the array
            currencyRateByDate.push(data);

            // Save updated array to localStorage
            localStorage.setItem('currencyRateByDate', JSON.stringify(currencyRateByDate));

            return data;
        } catch (error) {
            console.error('Error fetching currency data:', error);
            throw error;
        }
    }
}

export const getDecodedToken = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

export const formatDisableDate = (dateString) => {
    try {
        if (!dateString) return null;

        const date = new Date(dateString);
        const now = new Date();
        const difference = date.getTime() - now.getTime();

        if (difference <= 0) {
            return {
                formatted: 'Expired',
                daysUntil: 0,
                isPast: true,
                countdownString: 'Expired',
            };
        }

        // Format date for display
        const formattedDate = date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });

        // Calculate days until
        const daysUntil = Math.ceil(difference / (1000 * 60 * 60 * 24));

        return {
            formatted: formattedDate,
            daysUntil,
            isPast: false,
            countdownString: `${daysUntil} ${daysUntil === 1 ? 'day' : 'days'}`,
        };
    } catch (error) {
        console.error('Error parsing date:', error);
        return null;
    }
};

export const getCountdownDisplay = (dateString) => {
    try {
        if (!dateString) return 'Invalid date';

        const date = new Date(dateString);
        const now = new Date();
        const difference = date.getTime() - now.getTime();

        if (difference <= 0) {
            return 'Expired';
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        if (days > 7) {
            return `${days} days`;
        } else if (days > 0) {
            return `${days}d ${hours.toString().padStart(2, '0')}h`;
        } else if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m`;
        } else if (minutes > 0) {
            return `${minutes.toString().padStart(2, '0')}m ${seconds
                .toString()
                .padStart(2, '0')}s`;
        } else {
            return `${seconds.toString().padStart(2, '0')}s`;
        }
    } catch (error) {
        return 'Invalid date';
    }
};
